import * as translator from "../../../../utils/translator";

const TRUSTED_SHOPS_URL = process.env.REACT_APP_TRUSTED_SHOPS_URL || '';
const TRUSTED_SHOPS_REVIEW_URL = `${TRUSTED_SHOPS_URL}/bewertung/info_X330A2E1F5B774F249E05F41D9E2F0B41.html`;
const TRUSTED_SHOPS_IMPRINT_URL = `${TRUSTED_SHOPS_URL}/impressum/`;
const PRIVACY_POLICY_URL = `${TRUSTED_SHOPS_URL}/datenschutz/`;
const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || '';
const STARS_IMAGE_URL = `${IMAGES_URL}uploads/test-lab/5_stars.svg`;

interface Props {
    language?: string;
}

export default function TestLabRateWidget({ language = "de" }: Props) {
    const t = (key: string) => translator.translate(language, "thankyou", `page/${key}`);

    return (
        <section className="w-full flex justify-center px-4 py-8 lg:py-12">
            <div className="w-full max-w-[486px] bg-white border-[3px] border-solid border-[#61a333] rounded-[16px] flex flex-col items-center text-center px-0 pt-4 pb-4 overflow-hidden">

                {/* 5 stars */}
                <img
                    src={STARS_IMAGE_URL}
                    alt="5 Sterne"
                    className="w-[172px] h-auto mb-3"
                />

                {/* Heading */}
                <h3 className="font-poppins font-semibold text-black text-[24px] leading-[1.3] m-0 mb-0 px-6 text-center mt-2">
                    {t("test_lab_rate_heading")}
                </h3>

                {/* Body content */}
                <div className="w-full bg-white px-6 pt-[14px] flex flex-col gap-[20px]">

                    {/* Description */}
                    <p className="font-poppins font-normal text-[16px] text-black leading-[1.5] m-0 text-left">
                        {t("test_lab_rate_description")} (
                        <a
                            href={PRIVACY_POLICY_URL}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="text-[#005aa0] underline"
                        >
                            {t("test_lab_rate_privacy")}
                        </a>
                        ).
                    </p>

                    {/* CTA button */}
                    <a
                        href={TRUSTED_SHOPS_REVIEW_URL}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="
                            block w-full
                            bg-primary-button-gradient
                            hover:opacity-90
                            text-white font-poppins font-bold text-[16px] leading-[1.125]
                            py-[16px] px-4
                            rounded-[5px]
                            text-center no-underline
                            transition-opacity duration-200
                        "
                    >
                        {t("test_lab_rate_cta")}
                    </a>
                </div>

                {/* Footer */}
                <div className="w-full py-[10px] flex items-center justify-center">
                    <a
                        href={TRUSTED_SHOPS_IMPRINT_URL}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="font-poppins font-normal text-[11px] text-[#344054] no-underline"
                    >
                        {t("test_lab_rate_imprint")}
                    </a>
                </div>
            </div>
        </section>
    );
}
